export enum HttpError {
  OFFLINE = "OFFLINE",
  OTHER = "OTHER",
}

export default HttpError;
